var map = {
	"./avatar.png": 4947,
	"./desjardins-logo.png": 8182,
	"./myLogo.png": 7739,
	"./stackLogo/adobeillustrator.png": 6712,
	"./stackLogo/angular.png": 8294,
	"./stackLogo/api.png": 8724,
	"./stackLogo/apollo.png": 7992,
	"./stackLogo/auth0.png": 8390,
	"./stackLogo/bitbucket.png": 6812,
	"./stackLogo/bootstrap.png": 8642,
	"./stackLogo/css3.png": 9803,
	"./stackLogo/cypress.png": 1445,
	"./stackLogo/docker.png": 6379,
	"./stackLogo/eslint.png": 9809,
	"./stackLogo/figma.png": 6386,
	"./stackLogo/github.png": 4723,
	"./stackLogo/gitlab.png": 1448,
	"./stackLogo/graphql.png": 2064,
	"./stackLogo/grunt_js.png": 2481,
	"./stackLogo/gulp.png": 5242,
	"./stackLogo/html5.png": 4217,
	"./stackLogo/i18n.png": 6880,
	"./stackLogo/javascript.png": 1264,
	"./stackLogo/jenkins.png": 3190,
	"./stackLogo/jest.png": 7457,
	"./stackLogo/jira-new.png": 2926,
	"./stackLogo/jira.png": 8536,
	"./stackLogo/jquery.png": 5251,
	"./stackLogo/json.png": 7487,
	"./stackLogo/keycloak.png": 5407,
	"./stackLogo/lazyload.png": 1204,
	"./stackLogo/mantine.png": 5257,
	"./stackLogo/mongodb.png": 7402,
	"./stackLogo/mui.png": 5649,
	"./stackLogo/mysql.png": 9575,
	"./stackLogo/nestjs.png": 4729,
	"./stackLogo/nextjs.png": 5702,
	"./stackLogo/nodejs.png": 6453,
	"./stackLogo/npm.png": 6124,
	"./stackLogo/paas.png": 1188,
	"./stackLogo/pnpm.png": 2075,
	"./stackLogo/postman.png": 866,
	"./stackLogo/prettier.png": 6366,
	"./stackLogo/react.png": 7386,
	"./stackLogo/reactflow.png": 3132,
	"./stackLogo/reactquery.png": 7779,
	"./stackLogo/reactrouter.png": 4995,
	"./stackLogo/redux.png": 2519,
	"./stackLogo/saas.png": 2640,
	"./stackLogo/sass.png": 2736,
	"./stackLogo/semanticUi.png": 9662,
	"./stackLogo/storybook.png": 2205,
	"./stackLogo/tailwindcss.png": 9923,
	"./stackLogo/typescript.png": 6355,
	"./stackLogo/webpack.png": 6644,
	"./stackLogo/xstate.png": 2754,
	"./stackLogo/yarn.png": 3917,
	"./stackLogo/yup.png": 5679,
	"./stackLogo/zod.png": 2054,
	"./vigauto-logo.png": 338,
	"./work.png": 9410,
	"./zenika-logo.png": 7660
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 3778;